import { Form } from "@redriver/cinnamon-mui";
import { getExchangeRateSets } from "./actions";

const ExchangeRateSetDropdown = ({ ...props }) => (
  <Form.Dropdown {...props} lookupAction={getExchangeRateSets} />
);

export default ExchangeRateSetDropdown;
